import i18next from 'i18next';
import { TFunction } from 'i18next';
import { commonPaths } from '../../types/locales';


function getPluralizedText(key: commonPaths, count: number, additionalOptions = {}, t?: TFunction) {
  if (t) {
    return t(key, { count, ...additionalOptions });
  }
  return i18next.t(key, { count, ...additionalOptions });
}

export function getDaysText(count: number, t?: TFunction) {
  return getPluralizedText('common:plurals.days_with_count', count, {}, t);
}

export function getUpperDaysText(count: number, t?: TFunction) {
  return getPluralizedText('common:plurals.upper_days_with_count', count, {}, t);
}